
import { Alert, AlertDescription } from "@/components/ui/alert";

interface AuthStatusProps {
  error: string | null;
  userId: string | null;
  userRole: string | null;
}

export const AuthStatus = ({ error, userId, userRole }: AuthStatusProps) => {
  return (
    <>
      {error && (
        <Alert variant="destructive" className="mb-4">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      {userId && (
        <Alert className="mb-4">
          <AlertDescription>
            Current User ID: {userId}<br/>
            Role: {userRole}
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};
